// extracted by mini-css-extract-plugin
module.exports = {"container":"Products_container__HxiOl","item":"Products_item__20nCg","selected":"Products_selected__2AzbN"};